module.exports = __webpack_public_path__ + "img/wsk-run.4afb12b6.png";